import { IOrder } from '@checkout/payments';
import { IAddress, RootState } from '@checkout/state';
import * as cx from 'classnames';
import * as React from 'react';
import { Fragment } from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { paymentResultRequest } from '../../../reducers/checkout';
import { arrowNextIcon, orderSuccessIcon } from '../../../utils/icons';
import messages from './../../../i18n/base-en';
import { Summary, Widget } from './../../presentational';
import * as Styles from './Receipt.scss';

interface IOwnProps {}

interface IConnectedProps {
  order: IOrder;
}

interface IConnectetDispatchProps {
  paymentResultRequest: typeof paymentResultRequest;
}

type Props = IOwnProps & IConnectedProps & IConnectetDispatchProps & InjectedIntlProps;

class Receipt extends React.Component<Props, {}> {

  componentDidMount() {
    this.props.paymentResultRequest();
  }

  renderAddressSection = (title: string, addressData: IAddress) => {
    return (
      <Fragment>
        <div className={Styles.title}>{title}</div>
        <div className={Styles.row}>
          <p className={Styles.item}>{addressData.firstName} {addressData.lastName}</p>
          {addressData.company && <p className={Styles.item}>{addressData.company}</p>}
          <p className={Styles.item}>{addressData.address1}{addressData.address2 && `, ${addressData.address2}`}</p>
          {addressData.state ?
            <p className={Styles.item}>{addressData.zipCode} {addressData.city} {addressData.state}, {addressData.countryName}</p> :
            <p className={Styles.item}>{addressData.zipCode} {addressData.city}, {addressData.countryName}</p>}
        </div>
      </Fragment>
    );
  }

  render() {
    const { order, intl } = this.props;
    const { formatMessage } = intl;
    const {
      date,
      order: orderId,
      statusDescription,
      totals,
      items,
      address,
      shippingAddress,
      paymentMethodName,
      shippingMethodName,
      paymentMethodData,
      affiliateHtml } = order;

    if (Object.keys(order).length === 0 && order.constructor === Object) { return null; }

    const orderDetailsClassNames = cx({
      [Styles.row]: true,
      [Styles.orderDetailsRow]: true
    });

    const bottomSectionClassNames = cx({
      [Styles.section]: true,
      [Styles.bottomSection]: true
    });

    return (
      <div className={Styles.receipt}>

        {paymentMethodData && paymentMethodData.snippet && <Widget snippet={paymentMethodData.snippet} />}

        <div className={Styles.head}>
          <div className={Styles.icon}>{orderSuccessIcon}</div>
          <p className={Styles.header}>{formatMessage(messages.thank_message)}</p>
        </div>
        <div className={Styles.title}>{formatMessage(messages.order_details_label)}</div>
        <div className={Styles.columns}>
          <div className={Styles.column}>
            <div className={orderDetailsClassNames}>
              {formatMessage(messages.order_number_label)}
              <span className={Styles.value}>{orderId}</span>
            </div>
            <div className={orderDetailsClassNames}>
              {formatMessage(messages.order_date_label)}
              <span className={Styles.value}>{date}</span></div>
            <div className={orderDetailsClassNames}>
              {formatMessage(messages.order_status_label)}
              <span className={Styles.value}>{statusDescription}</span>
            </div>
          </div>
          <div className={Styles.column}>
            <div className={orderDetailsClassNames}>
              {formatMessage(messages.payment_method_receipt_title)}
              <span className={Styles.value}>{paymentMethodName}</span>
            </div>
            <div className={orderDetailsClassNames}>
              {formatMessage(messages.delivery_method_receipt_title)}
              <span className={Styles.value}>{shippingMethodName}</span>
            </div>
          </div>
        </div>
        <div className={Styles.columns}>
          <div className={Styles.column}>
            {this.renderAddressSection(formatMessage(messages.shipping_address_receipt_title), shippingAddress)}
          </div>
          <div className={Styles.column}>
            {this.renderAddressSection(formatMessage(messages.billing_address_receipt_title), address)}
          </div>
        </div>
        <div className={Styles.section}>
          <Summary totals={totals} items={items} title={formatMessage(messages.order_summary_receipt_title)} />
        </div>
        <div className={bottomSectionClassNames}>
          <button className={Styles.button} onClick={window.print}>{formatMessage(messages.print_receipt_label)}</button>
          <a href="/" className={Styles.button}>{formatMessage(messages.continue_shopping_receipt_link_label)}{arrowNextIcon}</a>
        </div>

        {affiliateHtml && <Widget snippet={affiliateHtml} />}

      </div>
    );
  }
}

export default compose<React.ComponentClass>(
  injectIntl,
  connect<IConnectedProps, IConnectetDispatchProps>(
    (state: RootState) => ({
      order: state.checkout.receipt.order,
    }),
    {
      paymentResultRequest,
    }
  ),
)(Receipt);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/container/Receipt/Receipt.tsx